import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './utils/analytics' // Initialize analytics tracking

createRoot(document.getElementById("root")!).render(<App />);
